"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Orientation = exports.BookType = exports.AssetType = exports.ReadAloudIframeConstants = exports.ReadingType = exports.FULL_SCREEN = exports.Locale = void 0;
var Locale;
(function (Locale) {
    Locale["ES_US"] = "es-US";
    Locale["EN_US"] = "en-US";
})(Locale = exports.Locale || (exports.Locale = {}));
exports.FULL_SCREEN = 'FULL_SCREEN';
var ReadingType;
(function (ReadingType) {
    ReadingType["ReadStory"] = "readStory";
    ReadingType["ReadAloud"] = "readAloud";
})(ReadingType = exports.ReadingType || (exports.ReadingType = {}));
var ReadAloudIframeConstants;
(function (ReadAloudIframeConstants) {
    ReadAloudIframeConstants["IFRAME_PAGE_ID_1"] = "IFRAME_PAGE_ID_1";
    ReadAloudIframeConstants["IFRAME_PAGE_ID_2"] = "IFRAME_PAGE_ID_2";
})(ReadAloudIframeConstants = exports.ReadAloudIframeConstants || (exports.ReadAloudIframeConstants = {}));
var AssetType;
(function (AssetType) {
    AssetType["AUDIO"] = "AUDIO";
    AssetType["DOCUMENT"] = "DOCUMENT";
    AssetType["IMAGE"] = "IMAGE";
    AssetType["SVG"] = "SVG";
    AssetType["VIDEO"] = "VIDEO";
})(AssetType = exports.AssetType || (exports.AssetType = {}));
var BookType;
(function (BookType) {
    BookType["LAP_BOOK"] = "LAP_BOOK";
    BookType["STUDENT_TEXT"] = "STUDENT_TEXT";
})(BookType = exports.BookType || (exports.BookType = {}));
var Orientation;
(function (Orientation) {
    Orientation["LANDSCAPE"] = "LANDSCAPE";
    Orientation["PORTRAIT"] = "PORTRAIT";
})(Orientation = exports.Orientation || (exports.Orientation = {}));
